import FixedHeader from './components/fixedHeader';
import OffCanvasNav from './components/offCanvasNav';
import SiteHeaderSearchToggle from './components/siteHeaderSearchToggle';
import SiteHeaderSearch from './components/siteHeaderSearch';
import LangSelect from './components/langSelect';
import HeroSlider from './components/heroSlider';
import FiftyFiftyBlock from './components/fiftyfiftyBlock';
import VideoGridBlock from './components/videoGridBlock';
import CaseCarousel from './components/caseCarousel';
import CaseGallerySlider from './components/caseGallerySlider';
import CaseArchive from './components/caseArchive';
import NewsArchive from './components/newsArchive';
import HeroBlock from './components/hero';
import MapBlock from './components/map';
import loadMore from './components/loadMore';
import staffSearch from './components/staffSearch';
import serviceSearch from './components/serviceSearch';
import OfficeArchive from './components/officeArchive';
import HomePageVideo from './components/homePageVideo';
import ContactFormModal from './components/contactFormModal';
import ReadMore from './components/readmore';
import FactsBlock from './components/factsBlock';

import { initLightboxGallery } from './components/lightboxGallery';
import { datajs, datajsAll } from './shared/utils';

document.addEventListener('DOMContentLoaded', () => {
	FixedHeader.init();
	OffCanvasNav.init();
	SiteHeaderSearchToggle.init();
	SiteHeaderSearch.init();
	LangSelect.init();
	ReadMore.init();
	FiftyFiftyBlock.init();
	VideoGridBlock.init();
	CaseCarousel.init();
	CaseGallerySlider.init();
	HeroBlock.init();
	MapBlock.init();
	CaseArchive.init();
	NewsArchive.init();
	OfficeArchive.init();
	HomePageVideo.init();
	ContactFormModal.init();
	loadMore();
	staffSearch();
	serviceSearch();

	// Enable count up numbers in fact blocks
	FactsBlock.init();

	// Enable triggering of cookiebot renewal from links
	const renewConsentLinks = document.querySelectorAll('a[href*="#cookiebot-renew"]');
	renewConsentLinks?.forEach((link) => {
		link?.addEventListener('click', (e) => {
			e.preventDefault();
			if (window.Cookiebot) {
				window.Cookiebot.renew();
			}
		});
	});

	// Only init HeroSlider after the first slider item has lazyloaded
	const firstImageSlide = document.querySelector('.m-pageHeaderSlideImage.swiper-slide:first-child');
	if (firstImageSlide) {
		const hasImage = firstImageSlide.querySelector('.m-pageHeaderSlideImage__media');
		if (hasImage) {
			firstImageSlide.addEventListener(
				'lazyloaded',
				() => {
					HeroSlider.init();
				},
				{ once: true }
			);
		} else {
			HeroSlider.init();
		}
	}

	// Toggle iframe fullscreen
	if (document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled) {
		datajsAll('iframe-slide')?.forEach((slide) => {
			const fullscreenBtn = datajs('toggle-iframe-fullscreen-btn', slide);
			const iframe = slide.querySelector('iframe');

			if (!iframe) {
				return;
			}

			// Show fullscreen button
			fullscreenBtn.classList.remove('d-none');

			// Toggle fullscreen on click
			fullscreenBtn.addEventListener('click', function (e) {
				e.preventDefault();
				if (iframe.requestFullscreen) {
					iframe.requestFullscreen();
				} else if (iframe.webkitRequestFullscreen) {
					iframe.webkitRequestFullscreen();
				} else if (iframe.mozRequestFullScreen) {
					iframe.mozRequestFullScreen();
				} else if (iframe.msRequestFullscreen) {
					iframe.msRequestFullscreen();
				}
			});
		});
	}

	// Init Photoswipe on native wordpress gallery
	if (document.querySelectorAll('.gallery').length) {
		initLightboxGallery('.gallery');
	}
	if (document.querySelectorAll('figure.wp-caption').length) {
		initLightboxGallery('figure.wp-caption');
	}

	// Remove Iframe and Video loader when ready
	document.addEventListener('lazyloaded', (e) => {
		const closestHasLoaderParent = e.target.closest('.has-loader');

		if (closestHasLoaderParent) {
			closestHasLoaderParent.classList.remove('has-loader');
		}
	});
});
